var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.12,
    height: 18.28,
    viewBox: "0 0 16.12 18.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calculator",
    "data-name": "Icon awesome-calculator",
    d: "M13.5,0H1.62A1.661,1.661,0,0,0,0,1.62V15.66a1.661,1.661,0,0,0,1.62,1.62H13.5a1.661,1.661,0,0,0,1.62-1.62V1.62A1.661,1.661,0,0,0,13.5,0ZM4.32,14.688a.465.465,0,0,1-.432.432h-1.3a.465.465,0,0,1-.432-.432v-1.3a.465.465,0,0,1,.432-.432h1.3a.465.465,0,0,1,.432.432Zm0-4.32a.465.465,0,0,1-.432.432h-1.3a.465.465,0,0,1-.432-.432v-1.3a.465.465,0,0,1,.432-.432h1.3a.465.465,0,0,1,.432.432Zm4.32,4.32a.465.465,0,0,1-.432.432h-1.3a.465.465,0,0,1-.432-.432v-1.3a.465.465,0,0,1,.432-.432h1.3a.465.465,0,0,1,.432.432Zm0-4.32a.465.465,0,0,1-.432.432h-1.3a.465.465,0,0,1-.432-.432v-1.3a.465.465,0,0,1,.432-.432h1.3a.465.465,0,0,1,.432.432Zm4.32,4.32a.465.465,0,0,1-.432.432h-1.3a.465.465,0,0,1-.432-.432V9.072a.465.465,0,0,1,.432-.432h1.3a.465.465,0,0,1,.432.432Zm0-8.64a.465.465,0,0,1-.432.432H2.592a.465.465,0,0,1-.432-.432V2.592a.465.465,0,0,1,.432-.432h9.936a.465.465,0,0,1,.432.432Z",
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#4477c0",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.962ea05d27fb8ff1cb41b50818e84735.svg";
export { ForwardRef as ReactComponent };